import { Attachments } from '@nv/components'
import { useTranslation } from 'react-i18next'
import styles from './VoterEventDetailsAttachments.module.scss'

export const VoterEventDetailsAttachments = ({ listOfDocs, getHelpDocs }) => {
  const { t } = useTranslation()
  // const currentLanguage = i18n.language
  // const [searchTerm, setSearchTerm] = useState('')
  // const filteredDocs = listOfDocs.filter(doc =>
  //   doc?.title?.[currentLanguage]?.toLowerCase()?.includes(searchTerm.toLowerCase())
  // )

  return (
    <>
      <div className={styles['attachments__header']}>
        <span className={styles['attachments__header__text']}>{t('events.labels.attachments')}</span>
        {/* <div className={styles['attachments__header__search']}>
            <SearchBar
              name='search'
              placeholder={t('main.search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div> */}
      </div>

      <Attachments listOfDocs={listOfDocs} getAttachments={getHelpDocs} viewOnly={true} />
    </>
  )
}
